'use client';

import ImageContentSlider from '@/components/organisms/content/news-image-slider';
import { TopVideosSection } from '@/components/organisms/content/top-videos';
import NewsImageSlider from '@/components/organisms/content/news-image-slider';
import React from 'react';


const NewsSliderTastic = ({ data }: any) => {

    return (
        <>
            <NewsImageSlider
                data={data?.data?.dataSource} />
        </>
    );
};

export default NewsSliderTastic;